import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { generateEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'

export const createWebsiteLogo = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): WebsiteLogoInterface => {
  return {
    ...generateEntity(EntityTypeEnum.WebsiteLogo, parentId, masterBlockId),
    logoFileId: null,
    logoText: 'Logo',
  }
}
